import { pickups, pickupsInterior, cards, residencias } from './data';
import axios from 'axios';
import queryString from 'query-string';

/**
 * Get pickup information from data
 * @param {string} id Pickup identifier
 */
export const getPickupInfo = (value, zona) => {
  if (!value) return null;

  if (zona === 'Montevideo') {
    return pickups.filter(pickup => pickup.value === value)[0];
  } else {
    return pickupsInterior.filter(pickup => pickup.value === value)[0];
  }
};

export const STORE_NAME = 'itau-prestamos-form';

export const clearSessionStorage = () => window.sessionStorage.setItem(STORE_NAME, '{data:{}}');

// Redirigir a la landing SIN parametros
export function redirectToLanding() {
  const parsed = queryString.parse(window.location.search);
  const baseUrl = window.location.href.split('?')[0];

  if (Object.keys(parsed).length === 0 && parsed.constructor === Object) {
    window.location.href = baseUrl;
  } else {
    window.location.href = `${baseUrl}?${queryString.stringify(
      { ...parsed, grupo: null, tipo: null },
      { skipNull: true },
    )}`;
  }
}

export const breakpoints = {
  md: `${process.env.REACT_APP_MOBILE_BREAKPOINT}px`,
};

export const colors = {
  baseBackgroundColor: '#f9fafb',
  baseTextColor: '#26221f',
  baseFontText: "'ItauText', sans-serif",
  baseFontDisplay: "'ItauDisplay', sans-serif",
  orange: '#ec7000',
  darkOrange: '#dd6100',
  lightOrange: '#ed7e19',
  grey: '#c8c8c8',
  darkGrey: '#464646',
  lighterGrey: '#ededed',
  pale: '#efe9e5',
  lightestGrey: '#f5f5f5',
  borderRadius: '4px',
  white: '#fff',
  black: '#312d2b',
  blue: '#106eb0',
  textMuted: '#969290',
  boxShadow: '0 1px 2px 0 rgba(91, 81, 73, 0.2)',
  brown: '#5d5750',
  brown2: '#5e5852',
  inputBorderColor: '#d9d3cf',
  lightPink: '#faf8f7',
  gridGutter: '10px',
  formErrorColor: 'firebrick',
  outline: 0,
};

export function getCards(cardId) {
  return cards?.find(card => card.id === cardId);
}

export function getCardTypes(cardId, types) {
  return types?.find(card => card.id === cardId);
}

const BASE_URL = process.env.REACT_APP_BASE_URL || '';
const API_URL = BASE_URL + '/pub/altasWeb/tarjetas/enviar/2';

axios.defaults.paramsSerializer = params => {
  return Object.entries(params)
    .map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
    .join('&');
};

export const submitForm = (data, captcha) => {
  let group = getCards(data.selectedGroup);
  let tipo = getCardTypes(data.selectedCard, group.types);

  let departamentoEntrega = data.entrega_department || '';
  let localidadEntrega = data.entrega_localidad || '';
  let domicilioEntrega = data.entrega_address || '';

  if (data.delivery === 'Retiro' && data.pickup && data.zona) {
    let pickupInfo = getPickupInfo(data.pickup, data.zona);
    departamentoEntrega = pickupInfo.departamento;
    localidadEntrega = pickupInfo.localidad;
    domicilioEntrega = pickupInfo.address;
  }

  // Filtrar parametros con prefijo utm
  const parsed = queryString.parse(window.location.search);
  let utmParams = Object.keys(parsed)
    .filter(key => key.includes('utm_'))
    .reduce((obj, key) => {
      return {
        ...obj,
        [key]: parsed[key],
      };
    }, {});

  let req = {
    tipo: group.label, // 'Volar', etc
    fechaCierre: '26',
    nombre: data.name,
    apellido: '-',
    documento: data.numero_cedula,
    programa: tipo.badge.title, // 'Regional', etc
    solProdTipoDoc: data.tipo_cedula,
    solProdDocumentoFolio: data.tipo_cedula === 'ci-vieja' ? data.folio_number : '',
    solProdDocumentoSerie: data.tipo_cedula === 'ci-vieja' ? data.folio_serie : '',
    solProdDocumentoCodSec: data.tipo_cedula === 'ci-nueva' ? data.cedula_codigo : '',
    telefonoContacto: data.phone,
    email: data.email,
    pais: 'Uruguay',
    departamento: data.department,
    localidad: data.localidad,
    domicilio: data.address,
    preferencia:
      data.delivery === 'domicilio' || data.delivery === 'otra_direccion'
        ? 'Entrega'
        : data.delivery,
    lugarEntrega: data.delivery === 'domicilio' ? 'Misma dirección de contacto' : '',
    departamentoEntrega: departamentoEntrega,
    localidadEntrega: localidadEntrega,
    domicilioEntrega: domicilioEntrega,
    horario: '',
    lugarRetiro: data.delivery === 'Retiro' ? data.pickup : '',
    departamentoRetiro: data.delivery === 'Retiro' ? data.zona : '',
    origen: data.origen || '',
    residencia: data.residencia || residencias[2].value,

    ...utmParams,
  };

  // console.log(req);

  return axios.post(
    API_URL,
    {},
    {
      params: req,
      headers: {
        'g-recaptcha-response': captcha,
      },
    },
  );
};

export function getOffersPersonales({ es_cliente = 'cliente-no', tipo_cuenta = [], tarjeta = [] }) {
  let offers = [];

  // console.log(es_cliente, tipo_cuenta, tarjeta);

  if (es_cliente === 'cliente-no') {
    offers = ['personales'];
  } else if (tipo_cuenta.includes('tipo_cuenta-cc')) {
    if (tarjeta.includes('tarjeta-visa')) {
      offers = ['personales', 'tc', 'sobregiro'];
    } else {
      offers = ['personales', 'sobregiro'];
    }
  } else if (tipo_cuenta.includes('tipo_cuenta-ca') && !tipo_cuenta.includes('tipo_cuenta-cc')) {
    if (tarjeta.includes('tarjeta-visa')) {
      offers = ['personales', 'tc'];
    } else {
      offers = ['personales'];
    }
  } else if (tipo_cuenta.includes('tipo_cuenta-no')) {
    if (tarjeta.includes('tarjeta-visa')) {
      offers = ['tc', 'personales'];
    } else {
      offers = ['personales'];
    }
  }

  console.log(offers);
  return offers;
}

export const LANDING_URL = `/inst/prestamos.html`;

// Obtiene las ofertas según los datos ingresados
export function getPrestamosConsumo(data) {
  // https://desa.itau.com.uy/pub/prestamos/consumo/ofertas
  const { monto, cuentas, tarjetas, moneda, tipoPaquete } = data;

  let tarjetasReq = tarjetas;

  if (tarjetas === 'MASTER') {
    // NOTE: Asumimos que si tiene Master es como no tener Ninguna tarjeta
    tarjetasReq = '--';
  } else if (tarjetas === 'AMBAS') {
    // NOTE: y si tiene ambas tarjetas toma solo Visa
    tarjetasReq = 'VISA';
  }

  let monedaCode = moneda;
  if (monedaCode === 'USD') {
    monedaCode = 'US.D';
  }

  const tipoPaqueteValue = tipoPaquete ? tipoPaquete : 'N';

  return axios
    .get(
      `${BASE_URL}/pub/prestamos/consumo/ofertas?monto=${monto}&cuentas=${cuentas}&tarjetas=${tarjetasReq}&moneda=${monedaCode}&tipoPaquete=${tipoPaqueteValue}`,
    )
    .then(response => response.data);
}

export const NO_TIENE_CUENTA_MESSAGE = `Para solicitar un préstamo en tu tarjeta de crédito online, tenés que tener una cuenta abierta en Itaú`;
export const NO_ES_CLIENTE_MESSAGE = `Para solicitar un préstamo tenés que tener una tarjeta de crédito Visa o una cuenta en Itaú`;
